import { render, staticRenderFns } from "./DashIntakeReferrals.vue?vue&type=template&id=5b0a671a&scoped=true&"
import script from "./DashIntakeReferrals.vue?vue&type=script&lang=js&"
export * from "./DashIntakeReferrals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0a671a",
  null
  
)

export default component.exports